// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".AccountSettings-module__accountForm--NU4dv {\n    display: flex;\n    flex-direction: column;\n    gap: 16px;\n}\n", "",{"version":3,"sources":["webpack://./src/components/settings/AccountSettings.module.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,sBAAsB;IACtB,SAAS;AACb","sourcesContent":[".accountForm {\n    display: flex;\n    flex-direction: column;\n    gap: 16px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"accountForm": "AccountSettings-module__accountForm--NU4dv"
};
export default ___CSS_LOADER_EXPORT___;
